var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.computedClass },
    [
      _c(
        "JadeText",
        {
          attrs: {
            color: "current-color",
            variant: "text-medium",
            weight: "medium",
            as: "label",
            for: _vm.htmlFor,
          },
        },
        [_vm._t("default")],
        2
      ),
      _vm.optional
        ? _c(
            "span",
            { staticClass: "jade-label__optional-indicator" },
            [
              _c(
                "JadeText",
                {
                  attrs: {
                    color: "current-color",
                    variant: "text-small",
                    weight: "regular",
                    as: "span",
                  },
                },
                [_vm._v(" Opcional ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }